const ORDERSTATUS = ["Unprocessed","Processing","Processed"];

let orderStatusList = [];
for(let i in ORDERSTATUS)
    orderStatusList.push({ID:i,Name:ORDERSTATUS[i]});

export { ORDERSTATUS,orderStatusList};
